import { Component, HostListener, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from "../../shared/services/translation/translation.service";
import { moduleType } from 'src/app/shared/models/module.type';
import { QuoterRequest } from 'src/app/shared/models/quoterRequest.model';

@Component({
  selector: 'app-premium-spotlight',
  standalone: false,
  templateUrl: './premium-spotlight.component.html',
  styleUrl: './premium-spotlight.component.scss'
})
export class PremiumSpotlightComponent {

  @Input() policytype: number;
  @Input() isPolicyTypeChoice: boolean = false;
  @Input() zipCode: number;
  @Input() startYear: number;
  @Input() processing: boolean = false;
  @Input() gaugeValue: number;
  @Input() annualPremium: number;

  constructor(
    private translate: TranslateService,
    public translationService: TranslationService,
    private route: ActivatedRoute
  ){
    this.quoterRequest = new QuoterRequest();
    this.route.params.subscribe(params => {
        this.policytype = parseInt(params.moduleType);
    });
  }
  quoterRequest: QuoterRequest;
  modules = moduleType;
  gaugeColor: string;

  getSpotlightTitleClass(): string {        
      let cssClass = 'title-font';
      if (this.translationService.currentLanguage == 'es') {
          cssClass = 'title-font title-font-es';
      }
      let hasHelpButton = this.policytype === this.modules.homeowner || this.policytype === this.modules.mobilehome;
      const title = this.getTitleText();        

      // adjust the title padding bottom depending on length of title (could be wrapping)
      if (title.length <= 15 || !hasHelpButton) {
          cssClass += ' pb-4';
      }

      return cssClass;
  }

  private getTitleText() : string {
        if (this.policytype === this.modules.homeowner && 
            !this.isPolicyTypeChoice) 
        {
            // homeowner
            return this.translate.instant('GLOBAL.Homeowners');
        } 
        else if (this.policytype === this.modules.homeowner && 
                this.isPolicyTypeChoice) 
        {
            // homeowner choice
            return this.translate.instant('GLOBAL.Homeowners Choice');
        } 
        else if (this.policytype === this.modules.renter)
        {
            // renter
            return this.translate.instant('GLOBAL.Renters');
        }
        else if (this.policytype === this.modules.condo)
        {
            // condo
            return this.translate.instant('GLOBAL.CONDO_OWNERS');
        }
        else if (this.policytype === this.modules.mobilehome && 
                !this.isPolicyTypeChoice)
        {
            // mobilehome
            return this.translate.instant('GLOBAL.Mobilehome');
        }
        else if (this.policytype === this.modules.mobilehome  && 
                this.isPolicyTypeChoice)
        {
            // mobilehome choice
            return this.translate.instant('GLOBAL.Mobilehome Choice');
        }
    }

    /*
    @HostListener('window:resize', ['$event'])
    onResize(event?) {
        this.gaugePosition();
    }
    */

    public getGaugeColor() {
        const portalElm = document.getElementById("block-portal-new-content--2");
        const rootStyles = window.getComputedStyle(portalElm ?? document.documentElement);
        return rootStyles.getPropertyValue('--css-cea-color-secondary');
    }

    public gaugePosition()
    {
        var collection = document.getElementsByClassName("actualGuage");
        if (collection && collection.length > 0) {
            var ele = collection[0];
            var rect = ele.getBoundingClientRect();
            //console.log("gauge:", rect.top, rect.right, rect.bottom, rect.left);
            alert("gauge: " + rect.top + " " + rect.right + " " + rect.bottom + " " + rect.left);
        }
    }
}
